import { action, observable } from 'mobx';
import { apiCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import _ from 'lodash';
import { Schema } from '@ui-library/formSchema';

export interface IDestinationDefsListStore {
  destinationDefs: IDestinationDef[];
  rootStore: IRootStore;
  getDestinationDefs(): void;
  getDestinationDef(id: string): IDestinationDef | undefined;
}

interface IAuthConfig {
  provider?: 'Google';
  type: string;
  secretFields: unknown[];
  nameField: string;
  config: Schema;
  role: string;
}
interface Config {
  supportedSourceTypes: string[];
  syncBehaviours: string[];
  destConfig: {
    defaultConfig: string[];
    [key: string]: string[];
  };
  preview: boolean;
  auth: IAuthConfig;
  supportsVisualMapper: boolean;
}

export interface IDestinationDef {
  id: string;
  name: string;
  displayName: string;
  category?: string;
  config?: Config;
  options?: {
    isBeta?: boolean;
  };
  isPopular: boolean;
}

const popularDestinations = [
  'WEBHOOK',
  'S3',
  'GA',
  'AM',
  'BQ',
  'POSTGRES',
  'SNOWFLAKE',
  'MP',
  'RS',
  'HS',
];

export class DestinationDefsListStore implements IDestinationDefsListStore {
  @observable public destinationDefs: IDestinationDef[] = [];

  @observable public rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
  }

  @action.bound
  public async getDestinationDefs() {
    const res = await apiCaller().get('/destination-definitions');
    this.destinationDefs = _.orderBy(
      res.data,
      [(dest) => dest.displayName?.toString().toLowerCase()],
      ['asc'],
    ).map((a) => ({ ...a, isPopular: popularDestinations.includes(a.name) }));
  }

  public getDestinationDef(id: string) {
    return this.destinationDefs.find((def: IDestinationDef) => def.id === id);
  }
}
